import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'


document.addEventListener('DOMContentLoaded', () => {
    let whatSlider = null;

    const mediaQuery = window.matchMedia('(min-width: 1280px)');

    const handleSlider = () => {

        if (mediaQuery.matches) {

            if (!whatSlider) {
                whatSlider = new Swiper('.faq-web-app__question-list-outstaffing', {
                    modules: [Navigation],
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    slideToClickedSlide: true,
                    loop: true,
                    centeredSlides: true,
                    slidesOffsetBefore: -162,
                    navigation: {
                        nextEl: '.faq-web-app__question-list-outstaffing .tab-next',
                        prevEl: '.faq-web-app__question-list-outstaffing .tab-prev',
                    },
                    breakpoints: {
                        1280: {
                            slidesOffsetBefore: -100,
                        },
                        1438: {
                            slidesOffsetBefore: -162,
                        }
                    }
                });
            }

        } else {

            if (whatSlider) {
                whatSlider.destroy(true, true);
                whatSlider = null;
            }

        }
    };

    handleSlider();

    mediaQuery.addEventListener('change', handleSlider);
});